<template>
    <div :style="styles"></div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: '#29c4a9'
    },
    height: {
      type: String,
      required: false,
      default: '3px'
    },
    transition: {
      type: Object,
      required: false,
      default: () => {
        return {
          duration: '500ms',
          mode: 'ease-in',
          property: 'width'
        }
      }
    }
  },
  computed: {
    styles: function () {
      return {
        'background-color': this.color,
        'height': this.height,
        'width': `${this.progress}%`,
        'transition': `${this.transition.duration} ${this.transition.mode}`,
        'transition-property': this.transition.property
      }
    }
  }
}
</script>
